import { render, staticRenderFns } from "./NewsCenterTable.vue?vue&type=template&id=7fb9c46f&scoped=true&"
import script from "./NewsCenterTable.vue?vue&type=script&lang=js&"
export * from "./NewsCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenterTable.vue?vue&type=style&index=0&id=7fb9c46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9c46f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
